import { Component } from '@angular/core';

@Component({
  selector: 'app-server-error-page',
  imports: [],
  templateUrl: './server-error-page.component.html',
  styleUrl: './server-error-page.component.scss',
  standalone: true
})
export class ServerErrorPageComponent {

}
